var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row reporting-metrics"},_vm._l((_vm.metrics),function(metric,i){return _c('div',{key:i,staticClass:"col-md-3"},[_c('stat',{attrs:{"title":metric.label,"value":metric.value}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }